import { Component, Input, OnInit } from '@angular/core';
import { SystemAlert } from '../../model/system-alert';
import { SystemAlertService } from '../../service/system-alert.service';

@Component({
  selector: 'app-system-alert-banner',
  templateUrl: './system-alert-banner.component.html',
  styleUrls: ['./system-alert-banner.component.scss'],
  providers: [SystemAlertService]
})
export class SystemAlertBannerComponent implements OnInit {
  @Input() overlayMode = false;

  systemAlerts: SystemAlert[] = [];
  expandedIds = new Set<number>();

  constructor(private systemAlertService: SystemAlertService) { }

  private readonly typePriority: Record<string, number> = { error: 0, warning: 1, success: 2, info: 3 };

  ngOnInit(): void {
    this.systemAlertService.fetchActive().subscribe(items => {
      this.systemAlerts = items
        .filter(a => a.active)
        .sort((a, b) => {
          const typeDiff = (this.typePriority[a.type] ?? 99) - (this.typePriority[b.type] ?? 99);
          return typeDiff !== 0 ? typeDiff : b.displayFrom.localeCompare(a.displayFrom);
        });
    });
  }

  hasBody(ann: SystemAlert): boolean {
    return !!(ann.body && ann.body.trim().length > 0);
  }

  toggleExpand(id: number): void {
    if (this.expandedIds.has(id)) {
      this.expandedIds.delete(id);
    } else {
      this.expandedIds.add(id);
    }
  }

  isExpanded(id: number): boolean {
    return this.expandedIds.has(id);
  }

  dismiss(id: number): void {
    this.systemAlerts = this.systemAlerts.filter(a => a.id !== id);
  }

  dismissAll(event: MouseEvent): void {
    event.preventDefault();
    this.systemAlerts = [];
  }

  typeIcon(type: string): string {
    const icons: Record<string, string> = {
      warning: 'warning',
      error: 'error',
      success: 'check_circle',
      info: 'info'
    };
    return icons[type] ?? 'info';
  }
}
